import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { SIGNALR_CONFIG } from "../constants/signalr";

let connection = null;

export const createHubConnection = async (token) => {
  if (!SIGNALR_CONFIG.HUB_URL) {
    console.warn(
      "🚫 SignalR disabled: Missing VITE_SIGNALR_HUB_URL env var. Add to .env.local",
    );
    console.info("💡 See .env.example for setup");
    return null;
  }

  if (connection) {
    await connection.stop();
  }

  connection = new HubConnectionBuilder()
    .withUrl(SIGNALR_CONFIG.HUB_URL, {
      accessTokenFactory: () => token,
    })
    .configureLogging(import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error)
    .withAutomaticReconnect()
    .build();

  // Common event handlers
  connection.on(SIGNALR_CONFIG.EVENTS.RECEIVE_NOTIFICATION, (_notification) => {
    // Dispatch to Redux or show toast
  });

  connection.on(SIGNALR_CONFIG.EVENTS.DATA_UPDATED, (_data) => {
    // Trigger refetch
  });

  try {
    await connection.start();

    return connection;
  } catch (error) {
    console.error("❌ SignalR Connection failed:", error);
    return null;
  }
};

export const stopHubConnection = async () => {
  if (connection) {
    await connection.stop();
    connection = null;
  }
};

export const invokeHubMethod = async (method, ...args) => {
  if (connection && connection.state === "Connected") {
    return connection.invoke(method, ...args);
  } else {
    console.warn("SignalR not connected");
    return null;
  }
};

export default connection;
